<button
  type="button"
  class="feedback-fab"
  (click)="openFeedback()"
  aria-label="Share feedback"
>
  <span class="feedback-fab__label">Share feedback</span>
  <mat-icon>add_comment</mat-icon>
</button>
